import { PROMOTION_STATUS } from '../../../../../Model/Promotion';

const texts = {
  searchPlaceholder: 'Search Promotions',
  columns: {
    description: 'Description',
    startDate: 'Start Date',
    endDate: 'End Date',
    status: 'Status',
  },
  PromotionStatus: {
    [PROMOTION_STATUS.UPCOMING]: 'Upcoming',
    [PROMOTION_STATUS.ONGOING]: 'Ongoing',
  },
  buttons: {
    edit: 'Edit',
    delete: 'Delete',
  },
  deletePromotionConfirmation: 'Are you sure you want to delete the promotion: \'{promotion}\'?',
  deleteSuccessful: 'Promotion deleted successfully',
  deleteFailed: 'Failed to delete promotion: {error}',
};

export default texts;
